export enum SEPARATOR {
  comma = ',',
  dot = '.',
  semicolon = ';'
}